export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif-display text-3xl leading-none">Porcelain</div>
          <p className="font-mono-label text-muted-foreground mt-2">Dental Sculpting Academy</p>
          <p className="text-sm text-muted-foreground mt-6 max-w-sm">
            A masterclass in additive wax-up, tooth morphology, and occlusion for students and practicing clinicians.
          </p>
        </div>
        <div>
          <div className="font-mono-label mb-4 text-foreground">Curriculum</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Wax-Up Fundamentals</li>
            <li>Anterior Morphology</li>
            <li>Posterior Morphology</li>
            <li>Occlusion & Function</li>
          </ul>
        </div>
        <div>
          <div className="font-mono-label mb-4 text-foreground">Studio</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>Anatomy Reference</li>
            <li>AI Tutor — Porcelain</li>
            <li>Progress Tracking</li>
            <li>Quizzes & Assessments</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground font-mono-label">
        © 2026 Porcelain Academy — crafted with precision.
      </div>
    </footer>
  );
}
